import React, { useState, useEffect } from 'react';
import {
  FaGift,
  FaHeart,
  FaStar,
  FaBirthdayCake,
  FaGem,
  FaCrown,
  FaRing,
  FaAppleAlt,
  GiPresent,
  GiDiamondRing,
  GiHeartNecklace,
  GiFlowerPot,
  GiCupcake
} from '../../icons';
import './GiftLoader.scss';

interface GiftLoaderProps {
  text?: string;
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

const GiftLoader: React.FC<GiftLoaderProps> = ({ 
  text = "Loading your gifts...", 
  size = 'medium',
  showText = true 
}) => {
  const [currentIconIndex, setCurrentIconIndex] = useState(0);
  
  const giftIcons = [
    { icon: FaGift, color: '#E74C3C' },
    { icon: GiPresent, color: '#9B59B6' },
    { icon: FaHeart, color: '#E91E63' },
    { icon: FaStar, color: '#F39C12' },
    { icon: FaBirthdayCake, color: '#FF6B6B' },
    { icon: GiDiamondRing, color: '#3498DB' },
    { icon: FaGem, color: '#1ABC9C' },
    { icon: GiHeartNecklace, color: '#E74C3C' },
    { icon: FaCrown, color: '#F1C40F' },
    { icon: GiFlowerPot, color: '#2ECC71' },
    { icon: FaRing, color: '#9B59B6' },
    { icon: GiCupcake, color: '#FF69B4' },
    { icon: FaAppleAlt, color: '#FF1493' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIconIndex((prevIndex) => 
        (prevIndex + 1) % giftIcons.length
      );
    }, 500); // Change icon every 500ms

    return () => clearInterval(interval);
  }, [giftIcons.length]);

  const CurrentIcon = giftIcons[currentIconIndex].icon;
  const currentColor = giftIcons[currentIconIndex].color;

  return (
    <div className={`gift-loader ${size}`}>
      <div className="loader-container">
        {/* Main rotating icon */}
        <div 
          className="main-icon"
          style={{ color: currentColor }}
        >
          <CurrentIcon />
        </div>
        
        {/* Floating icons around the main icon */}
        <div className="floating-icons">
          {giftIcons.slice(0, 6).map((iconData, index) => {
            const Icon = iconData.icon;
            return (
              <div 
                key={index}
                className={`floating-icon icon-${index}`}
                style={{ 
                  color: iconData.color,
                  animationDelay: `${index * 0.2}s`
                }}
              >
                <Icon />
              </div>
            );
          })}
        </div>
        
        {/* Sparkle effects */}
        <div className="sparkles">
          {Array.from({ length: 8 }).map((_, index) => (
            <div 
              key={index}
              className={`sparkle sparkle-${index}`}
              style={{ animationDelay: `${index * 0.3}s` }}
            >
              ✨
            </div>
          ))}
        </div>
      </div>
      
      {showText && (
        <div className="loader-text">
          <span className="loading-text">{text}</span>
          <div className="dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GiftLoader;